export default __webpack_public_path__ + "static/HalvarBreit-Lt-a8b34b16bd12cc6a16ce216b7121d3c4.woff2";